import * as yup from "yup"

const schemaValidationSafety = yup.object().shape({})

export default schemaValidationSafety
